import apiClient from '@/services/PricingapiClient'
export default {
    //<!-----------------------------credit api's-------------------------------->
    /**
     * get tax index page
     * @param {} page 
     * @param {*} count 
     * @param {*} search 
     * @param {*} status 
     */
    getPricingLists(page, show, search, status, sort, label, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/pricinglist/index/' + page + '/' + show + '?search=' + search + '&status=' + status + '&sort=' + sort + '&label=' + label)
    },
    postpricelist(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/pricinglist/create', data)
    },
    postupdatepricelist(id, data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/pricinglist/update/' + id, data)
    },
    getpricelist(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/pricinglist/view/' + id)
    },
    statuschange(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/pricinglist/statuschange/', data)
    },
    deletepricelist(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/pricinglist/singledelete/', data)
    },
    getPriceListDetails(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/pricinglist/details')
    },
    getproductlist(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/pricinglist/getproductlist?id=' + id)
    },
    totalcount(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/pricinglist/totalcount', data)
    },

}